// import custom components
import CircleSvg from "@/elements/Shared/SVGs/Circle/CircleSvg";

// import styles
import styles from "./circle.module.scss";

// import utils
import { handleBorderSize, handleColorStyle } from "@/utils/Circles";

//import interfaces
import CirclesProps from "@/interfaces/CirclesProps";

type Props = {
  circle: CirclesProps;
  circleId?: string;
  linearGradientId?: string;
  className?: string;
  pathId?: string;
};

export default function Circle({
  circle: {
    isSvg = false,
    isOnTopContainer = false,
    isAlternativeColor,
    isVisibleOnMobile,
    borderSize = "small",
    colorStyle,
    isAllSizeEgal = true,
    styleNumber,
  },
  circleId,
  linearGradientId,
  className = "",
  pathId = "",
}: Props) {
  function handleSizePosition(styleNumber) {
    switch (styleNumber) {
      case 1:
        return styles._circle_style_one;
      case 2:
        return styles._circle_style_two;
      case 3:
        return styles._circle_style_three;
      case 4:
        return styles._circle_style_four;
      case 5:
        return styles._circle_style_five;
      case 6:
        return styles._circle_style_six;
      case 7:
        return styles._circle_style_seveen;
      case 8:
        return styles._circle_style_eight;
      case 9:
        return styles._circle_style_nine;
      case 10:
        return styles._circle_style_ten;
      case 11:
        return styles._circle_style_eleveen;
      case 12:
        return styles._circle_style_twelve;
      case 13:
        return styles._circle_style_thirdteen;
    }
  }

  function handleColorSvg() {
    switch (colorStyle) {
      case 1:
        return [
          { color: "#806BDC", offset: 0 },
          { color: "#D580B7", offset: 50 },
          { color: "#f488ab", offset: 100 },
        ];
      case 2:
        return [{ color: "#e6e8fb", offset: 0 }];
      case 3:
        return [{ color: "#5f6bd3", offset: 0 }];
      case 4:
        return [{ color: "#4a59f2", offset: 0 }];
      case 5:
        return [{ color: "#0f21d8", offset: 0 }];
      case 6:
        return [{ color: "#342fd0", offset: 0 }];
      case 7:
        return [{ color: "#707070", offset: 0 }];
      case 8:
        return [{ color: "#ca94ad45", offset: 0 }];
      case 9:
        return [{ color: "#fff", offset: 0 }];
      case 10:
        return [{ color: "rgba(15,33,216,0.20)", offset: 0 }];
    }
  }

  function handleSvgTransformMatrixOutput() {
    if (borderSize === "small") return "matrix(-1 0 0 -1 643 0)";
    else return "matrix(0.8 0 0 0.8 70 570)";
  }

  if (isSvg)
    return (
      <CircleSvg
        pathId={pathId}
        circleId={circleId}
        linearGradientId={linearGradientId}
        stopColor={handleColorSvg()}
        classList={`${styles._default} ${
          isOnTopContainer ? styles._on_top : ""
        } ${!isAllSizeEgal ? handleSizePosition(styleNumber) : ""} ${
          !isVisibleOnMobile ? styles._hidden : ""
        }`}
        className={className}
        matrix={handleSvgTransformMatrixOutput()}
      />
    );

  return (
    <>
      {isAllSizeEgal ? (
        <span
          id={circleId}
          className={`${className} ${styles._default} ${handleBorderSize({
            isSvg,
            borderSize,
            styles,
          })} ${handleColorStyle({
            isSvg,
            colorStyle,
            styles,
          })} ${isOnTopContainer ? styles._on_top : ""} ${
            !isVisibleOnMobile ? styles._hidden : ""
          } ${isAlternativeColor ? styles._alternative : ""}`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlSpace="preserve"
            viewBox="0 0 150 150"
          >
            {colorStyle === 1 && (
              <defs>
                <linearGradient
                  id={linearGradientId}
                  gradientTransform="rotate(287)"
                >
                  <stop offset="0%" stopColor="#0f21d8" />
                  <stop offset="88%" stopColor="#bc0c3d" />
                  <stop offset="100%" stopColor="#d30929" />
                </linearGradient>
              </defs>
            )}
            <path
              id={pathId}
              d="M75 .25c41.22 0 74.75 33.53 74.75 74.75S116.22 149.75 75 149.75.25 116.22.25 75 33.78.25 75 .25M75 0C33.58 0 0 33.58 0 75s33.58 75 75 75 75-33.58 75-75S116.42 0 75 0z"
              fill={`url('#${linearGradientId}')`}
            />
          </svg>
        </span>
      ) : (
        <span
          id={circleId}
          className={`${className} ${styles._default} ${handleBorderSize({
            isSvg,
            borderSize,
            styles,
          })} ${handleColorStyle({
            isSvg,
            colorStyle,
            styles,
          })} ${handleSizePosition(styleNumber)} ${
            isOnTopContainer ? styles._on_top : ""
          } ${!isVisibleOnMobile ? styles._hidden : ""}${
            isAlternativeColor ? styles._alternative : ""
          }`}
        ></span>
      )}
    </>
  );
}
